import { Accordion } from "react-bootstrap";
import { useState } from "react";
const SubactivityComponent = ({
  fy_list,
  globalDateId,
  data,
  subheadName,
  subheadId,
  activity,
  subActivity
}) => {
  const [activeKeys, setActiveKeys] = useState([]);

  const toggleAccordion = (key) => {
    setActiveKeys(
      (prevKeys) =>
        prevKeys.includes(key)
          ? prevKeys.filter((k) => k !== key) // Remove key if it's already open
          : [...prevKeys, key] // Add key if it's closed
    );
  };
//   console.log("subactivity data", data);
  return (
    <>
    {data?.map((act, activityIndex) => (
        <Accordion style={{ border: "0" }} key={activityIndex}>
            <Accordion.Item
                eventKey={`suubhead_activity_${subheadId}_${activityIndex}`}
                style={{ borderRadius: "0", border: "0" }}
            >
                <Accordion.Header
                onClick={() => toggleAccordion(`suubhead_activity_${subheadId}_${activityIndex}`)}
                >
                <div className="w-100 d-flex justify-content-between">
                    <span>{subheadName} || {activity?.find(e => Number(e.id) === Number(act.activity_id))?.activity || 'N/A'}</span>
                    <span
                    className="d-flex justify-content-center align-items-center bg-success-100 text-white rounded-circle"
                    style={{
                        height: "13.33px",
                        width: "13.33px",
                    }}
                    >
                    {activeKeys.includes(`suubhead_activity_${subheadId}_${activityIndex}`) ? "-" : "+"}
                    </span>
                </div>
                </Accordion.Header>
                <Accordion.Body>
                    <div className="row">
                        <div className="row pt-2 m-0">
                        <div className="col-3 d-flex justify-content-between align-items-center">
                            <span className="text-black-60 fs-12px">Subactivity</span>
                        </div>
                        <div className="col-3 d-flex justify-content-between align-items-center">
                            <span className="text-black-60 fs-12px">
                            FY{" "}
                            {fy_list?.map((val, ind) => {
                                return val?.id == globalDateId && val?.year;
                            })}
                            </span>
                        </div>
                        <div className="col-3 d-flex justify-content-between align-items-center">
                            <span className="text-black-60 fs-12px">
                            Previous FY Balance
                            </span>
                            <i className="icon-info"></i>
                        </div>
                        <div className="col-3 d-flex justify-content-between align-items-center">
                            <span className="text-black-60 fs-12px">Total</span>
                        </div>
                        </div>
                        {/* ===================================values================================= */}
                        
                        {act?.subactivities?.map((subact, subactivityIndex) => {
                            // Find subactivity name
                            const subactivityName = subActivity?.find(e => Number(e.id) === Number(subact.subactivity_id))?.subactivity || 'N/A';
                            
                            return (
                                <>
                                    <div className="row pb-2 m-0 subactivity-row" key={subactivityIndex}>
                                        <div className="col-3 d-flex align-items-center">
                                        {!activeKeys.includes(`activity_${subact.subactivity_id}_${subheadId}`) ? (
                                            <i
                                            className="icon-keyboard_arrow_right cursor-pointer"
                                            onClick={() => toggleAccordion(`activity_${subact.subactivity_id}_${subheadId}`)}
                                            ></i>
                                        ) : (
                                            <i
                                            className="icon-keyboard_arrow_down cursor-pointer"
                                            onClick={() => toggleAccordion(`activity_${subact.subactivity_id}_${subheadId}`)}
                                            ></i>
                                        )}
                                        <span className="fs-14px fw-500">{subactivityName}</span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                        <span className="fs-14px fw-500">{subact.from_current_fy?.toLocaleString('en-IN') || '0.00'}</span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                        <span className="fs-14px fw-500">{subact.from_prev_fy?.toLocaleString('en-IN') || '0.00'}</span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                        <span className="fs-14px fw-500 text-success-100">
                                            {((subact.from_current_fy || 0) + (subact.from_prev_fy || 0))?.toLocaleString('en-IN')}
                                        </span>
                                        </div>
                                    </div>
                                    {activeKeys.includes(`activity_${subact.subactivity_id}_${subheadId}`) && (
                                    <div>
                                        <div className="row pb-2 m-0">
                                        <div className="col-3 d-flex align-items-center">
                                            <span className="fs-14px fw-500">&nbsp; Vendor</span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                            <span className="fs-14px fw-500">
                                            {subact.current_fy_detail?.vendor?.toLocaleString('en-IN') || '0.00'}
                                            </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                            <span className="fs-14px fw-500">
                                            {subact.prev_fy_detail?.vendor?.toLocaleString('en-IN') || '0.00'}
                                            </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                            <span className="fs-14px fw-500 text-success-100">
                                            {(subact.current_fy_detail?.vendor || 0 + subact.prev_fy_detail?.vendor || 0)?.toLocaleString('en-IN')}
                                            </span>
                                        </div>
                                        </div>
                                        <div className="row pb-2 m-0">
                                        <div className="col-3 d-flex align-items-center">
                                            <span className="fs-14px fw-500">&nbsp; DBT/NACH</span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                            <span className="fs-14px fw-500">
                                            {subact.current_fy_detail?.reimbursement?.toLocaleString('en-IN') || '0.00'}
                                            </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                            <span className="fs-14px fw-500">
                                            {subact.prev_fy_detail?.reimbursement?.toLocaleString('en-IN') || '0.00'}
                                            </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                            <span className="fs-14px fw-500 text-success-100">
                                            {(subact.current_fy_detail?.reimbursement || 0 + subact.prev_fy_detail?.reimbursement || 0)?.toLocaleString('en-IN')}
                                            </span>
                                        </div>
                                        </div>
                                        <div className="row pb-2 m-0">
                                        <div className="col-3 d-flex align-items-center">
                                            <span className="fs-14px fw-500">&nbsp; Salary</span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                            <span className="fs-14px fw-500">
                                            {subact.current_fy_detail?.salaries?.toLocaleString('en-IN') || '0.00'}
                                            </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                            <span className="fs-14px fw-500">
                                            {subact.prev_fy_detail?.salaries?.toLocaleString('en-IN') || '0.00'}
                                            </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                            <span className="fs-14px fw-500 text-success-100">
                                            {(subact.current_fy_detail?.salaries || 0 + subact.prev_fy_detail?.salaries || 0)?.toLocaleString('en-IN')}
                                            </span>
                                        </div>
                                        </div>
                                        <div className="row pb-2 m-0">
                                        <div className="col-3 d-flex align-items-center">
                                            <span className="fs-14px fw-500">
                                            &nbsp; Budget Allocation
                                            </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                            <span className="fs-14px fw-500">
                                            {subact.current_fy_detail?.allocation?.toLocaleString('en-IN') || '0.00'}
                                            </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                            <span className="fs-14px fw-500">
                                            {subact.prev_fy_detail?.allocation?.toLocaleString('en-IN') || '0.00'}
                                            </span>
                                        </div>
                                        <div className="col-3 d-flex justify-content-between align-items-center">
                                            <span className="fs-14px fw-500 text-success-100">
                                            {(subact.current_fy_detail?.allocation || 0 + subact.prev_fy_detail?.allocation || 0)?.toLocaleString('en-IN')}
                                            </span>
                                        </div>
                                        </div>
                                    </div>
                                    )}
                                </>
                            );
                        })}
                        {/* ==============================sub data========================== */}
                    </div>
                </Accordion.Body>
            </Accordion.Item>
            </Accordion>
    ))}
  </>  
  );
  
};

export default SubactivityComponent;


